import { createFileRoute } from "@tanstack/react-router";



export const Route = createFileRoute("/_protected/delivery/content/")({
  head: () => ({
    meta: [{ title: "内容管理 · imiker CRM" }],
  })
});
